import styled from 'styled-components';
import SvgIcon from '../SvgIcon';

const IconMinus = styled(SvgIcon).attrs({
  children: ({ color }: { color: string }) => (
    <rect width="8" height="2" x="4" y="7" fill={color} rx="0" />
  ),
})``;

export default IconMinus;
